import { Card } from "@/components/ui/Card";
import DeparmentTable from "./component/table";
import useDocumentTitle from "@/hooks/UseDocumentTitle";

const Department = () => {
  useDocumentTitle("Department Management");

  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <DeparmentTable />
      </Card>
    </div>
  );
};

export default Department;
